import { Checkbox } from "@/components/ui/checkbox";
import { Tag } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { isPromoOn, setPromoOn } from "@/lib/promoChoice";

export const PromoPicker = ({ promos, onChange, testid = "promo-picker", className = "" }) => {
  const { t } = useI18n();
  if (!promos.length) return null;
  return (
    <div className={`sticky top-16 z-30 -mx-4 sm:-mx-6 lg:-mx-8 mb-4 px-4 sm:px-6 lg:px-8 py-2.5 bg-background/95 backdrop-blur border-b border-primary/30 ${className}`} data-testid={testid}>
      <div className="flex items-center gap-2 flex-wrap justify-center">
        <span className="inline-flex items-center gap-1.5 text-sm font-semibold"><Tag className="w-4 h-4 text-primary" /> {t("Appliquer la promotion :")}</span>
        {promos.map((p) => (
          <label key={p.id} className="flex items-center gap-2 text-sm cursor-pointer rounded-lg border border-primary/40 bg-primary/5 px-3 py-1" data-testid={`${testid}-${p.id}`}>
            <Checkbox checked={isPromoOn(p)} onCheckedChange={(v) => { setPromoOn(p, !!v, promos); onChange(); }} data-testid={`${testid}-check-${p.id}`} />
            <span className="font-medium">{p.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
